<script setup>
import { watch } from "vue";
import { useDraggableModal } from "@/composables/useDraggableModal";

const props = defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["close"]);

// 🔹 NOVO: arrastar o modal pelo título (não há cabeçalho próprio aqui).
// Este componente não desmonta entre aberturas (só alterna `show`), então
// recentraliza ao reabrir para a posição não persistir.
const {
  panelRef,
  panelStyle,
  isDragging,
  isDraggable,
  onHandlePointerDown,
  resetPosition,
} = useDraggableModal();

watch(
  () => props.show,
  (val) => {
    if (val) resetPosition();
  }
);

function closeModal() {
  emit("close");
}
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[9998] flex items-center justify-center bg-black/20"
    @click.self="closeModal"
  >
    <div
      ref="panelRef"
      :style="panelStyle"
      class="bg-surface rounded-lg p-4 max-w-md w-full shadow-lg max-h-[80vh] overflow-y-auto"
    >
      <h2
        class="text-xl font-semibold mb-3"
        :class="{
 'cursor-move select-none touch-none': isDraggable,
          'cursor-grabbing': isDragging,
        }"
        @pointerdown="onHandlePointerDown"
      >Sobre a seção de tags de nota</h2>

      <p class="text-sm leading-relaxed text-gray-800 mb-3">
        Nesta página você gerencia as <strong>tags de nota</strong>, usadas para
        classificar as anotações feitas em textos. Cada tag pode
        ter cores específicas para destaque.
      </p>

      <ul
        class="list-disc pl-5 text-sm text-gray-700 space-y-1.5 mb-3"
      >
        <li>Use o campo de busca para encontrar tags rapidamente pelo nome.</li>

        <li>
          A coluna <strong>Tag</strong> exibe o nome que aparecerá nas notas e
          nos filtros.
        </li>

        <li>
          As colunas <strong>Nota única palavra</strong> e
          <strong>Nota várias palavras</strong> exibem um
          <em>preview visual</em> de como o destaque aparecerá no texto: cor de
          texto, fundo e sublinhado.
        </li>

        <li>
          Ao editar uma tag, você pode ajustar as cores conforme sua necessidade
          de organização e leitura.
        </li>

        <li>
          Marque várias tags para realizar
          <strong>exclusões em lote</strong> pelo menu “Ações em lote”.
        </li>

        <li>
          Clique em uma linha da tabela para abrir o
          <strong>cartão de detalhes</strong> com informações completas da tag.
        </li>
      </ul>

      <p
        class="text-xs text-gray-600 border-t pt-2 mt-2 leading-relaxed"
      >
        Dica: cadastre nomes de tags curtos e intuitivos para facilitar a identificação
         visual no texto e a precisão dos filtros durante a busca.
      </p>

      <div class="mt-3 text-right">
        <button
          @click="closeModal"
          class="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>


